import type { ConnectionCredentials, DriverConnectInfo } from '@nx/constants';
import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

export type LocalConnectionInfo = {
  driverConnectInfo: DriverConnectInfo;
  selectedDatabase: string;
  dbVersion: string | null;
  connectionType: ConnectionCredentials['type'];
};

export interface LocalConnectionState {
  connectionInfo: LocalConnectionInfo | null;
}

const initialState: LocalConnectionState = {
  connectionInfo: null,
};

export const localConnectionSlice = createSlice({
  name: 'localConnection',
  initialState,
  reducers: {
    storeConnection: (state, action: PayloadAction<LocalConnectionInfo>) => {
      state.connectionInfo = action.payload;
    },
    clearConnection: (state) => {
      state.connectionInfo = null;
    },
  },
});

export const { storeConnection, clearConnection } = localConnectionSlice.actions;

export const getLocalConnection = (state: { localConnection: LocalConnectionState }) =>
  state.localConnection.connectionInfo;

export default localConnectionSlice.reducer;
